

































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";

class DataPushSetDto {
    isAll: boolean;
    dataPushId: number;
    deviceId: any[] = [];
    operator: boolean;
}

@Component({
    components: {},
})



export default class DataPushSet extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: Array, default: [] }) meterlist: Array<any>;
    dataPushSetDto: DataPushSetDto = new DataPushSetDto();

    loading: boolean = false;
    create() { }
    created() {

    }
    save() {
        (this.$refs.itemForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                let res = await this.$store
                    .dispatch({
                        type: "datapush/setDataPush",
                        data: this.dataPushSetDto,
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$Modal.info({
                            title: this.L("Tips"),
                            content: err,
                        });
                    });
                this.$Modal.info({
                    title: this.L("Tips"),
                    content: res,
                });
                this.loading = false;
                (this.$refs.itemForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.itemForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.getDataPush();
        }
    }
    itemRule = {
        dataPushId: [
            {
                required: true,
                type: "number",
                message: this.L("PleasChoose"),
                trigger: "blur",
            },
        ],
    };
    async getDataPush() {
        await this.$store
            .dispatch("datapush/getAllDataPush")
            .then((val) => {
                if (val.length > 0) {
                    this.$data.optionsMechanism = [];
                    this.$data.optionsMechanism.push({ label: this.L("Cancel"), value: 0 });
                    val.forEach((ele) => {
                        this.$data.optionsMechanism.push({
                            label: ele.name,
                            value: ele.id,
                        });
                    });
                }
            })
            .catch((err) => {
                this.$Modal.info({
                    title: this.L("Tips"),
                    content: err,
                });
            });
    }
    data() {
        return {
            optionsMechanism: [],
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
    @Watch("meterlist")
    getitemId() {
        this.dataPushSetDto.deviceId = this.meterlist;
    }
}
